<div>
    <img [ngClass]="cls"  
    (click)="init_list()" 
    [src]="data.profile_pic" 
    data-toggle="modal" 
    data-target=".bdb-example-modal-xl">
</div>

<div 
  *ngIf="showdata"
  class="modal fade bdb-example-modal-xl" tabindex="-1"
   role="dialog"  data-keyboard="false" data-backdrop="static" 
   aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
  
   >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">操作</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body"> 
          <div class="user_edit_block">
            暱稱:{{showdata.name}}( {{showdata.uid}} )
          </div>
          <div class="user_edit_block">
            通知開關:{{showdata.local_push_status==1?'開':'關'}}
          </div>
          <div class="user_edit_block">
            國家:{{showdata.country_code}}
          </div>
          <div class="user_edit_block">
            電話:{{showdata.phone_num}}
          </div>
          <div class="user_edit_block">
            平台:{{showdata.os_type==2?'iOS':'Android'}}
          </div>
          <div class="user_edit_block">
            大頭貼
            <img style="height: 100px;" [src]="showdata.profile_pic">
            <button (click)="showdata.profile_pic=iconPic" style="margin: 10px;" class=" btn-danger btn" >預設</button>
          </div>
          <div class="user_edit_block" *ngIf="power*1==5">
            提領匯率
            <input type="range" [disabled]="showdata.gender*1==1 ? true : null"  class="form-range" min="0" max="0.7" step="0.1" [(ngModel)]="showdata.customer_rate" id="customRange1">
            {{showdata.customer_rate}}<span class="msg" *ngIf="showdata.gender*1==1">男生無法提領</span>
          </div>
          <div class="user_edit_block" *ngIf="power*1>=3">
            推薦分數
            <input type="range" class="form-range" min="1" max="9" step="1" [(ngModel)]="showdata.sort_score" >
            {{showdata.sort_score}}
          </div>
          <div class="user_edit_block" *ngIf="power*1==5">
            帳號使用狀態
            <button [ngClass]="showdata.is_enable==0?'btn-danger':'btn-secondary'"  (click)="showdata.is_enable=0" class="btn" >停權</button>
            <button [ngClass]="showdata.is_enable==1?'btn-danger':'btn-secondary'" (click)="showdata.is_enable=1" class="btn" >正常</button>
            <input *ngIf="showdata.is_enable==0" type="text" [(ngModel)]="showdata.block_reason" class="form-control fix_input"  placeholder="停權原因" >
          </div>
          <div class="user_edit_block" *ngIf="power*1==5">
            帳號身分
            <button [ngClass]="showdata.identity==1?'btn-danger':'btn-secondary'"  (click)="showdata.identity=1" class="btn" >一般會員</button>
            <button [ngClass]="showdata.identity==2?'btn-danger':'btn-secondary'" (click)="showdata.identity=2" class="btn" >內部員工</button>
            <button [ngClass]="showdata.identity==3?'btn-danger':'btn-secondary'" (click)="showdata.identity=3" class="btn" >簽約員工</button>
            <button [ngClass]="showdata.identity==5?'btn-danger':'btn-secondary'" (click)="showdata.identity=5" class="btn" >陪聊員工</button>
            <button [ngClass]="showdata.identity==6?'btn-danger':'btn-secondary'" (click)="showdata.identity=6" class="btn" >平台內主播</button>
          </div>
          <div class="user_edit_block" *ngIf="power*1==5">
            是否淺水
            <button [ngClass]="showdata.is_hidden==0?'btn-danger':'btn-secondary'"  (click)="showdata.is_hidden=0" class="btn" >正常</button>
            <button [ngClass]="showdata.is_hidden==1?'btn-danger':'btn-secondary'" (click)="showdata.is_hidden=1" class="btn" >淺水</button>
          </div>
          <div class="user_edit_block">
            招呼語
            <input type="text" [(ngModel)]="showdata.greeting" class="form-control fix_input">
            <button (click)="showdata.greeting='找我聊天嗎'" class=" btn-danger btn" >預設</button>
          </div>
          <div class="user_edit_block">
            自我介紹
            <input type="text" [(ngModel)]="showdata.introduction" class="form-control fix_input" >
            <button (click)="showdata.introduction='安安想認識我嗎'" class=" btn-danger btn" >預設</button>
          </div>
          <div class="user_edit_block" *ngIf="power*1==5">
            手動上傳紀錄
            <a *ngIf="showdata.log!=-1" href="{{showdata.log_link}}" target="_blank">link</a>
            <span *ngIf="showdata.log==-1">無資料
            </span>
          </div>
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button"   class="btn btn-primary">確認</button>
            <button id="ModalClose" type="button"  class="btn btn-danger" data-dismiss="modal">取消</button>
        </div>
        </div>
    </div>
  </div>